import { atom } from "recoil";


export const disabledState = atom({
    key: 'disabledState', // unique ID (with respect to other atoms/selectors)
    default: true, // default value (aka initial value)
  });
